<router-outlet></router-outlet>
<div
  *ngIf="envName !== 'prod'"
  class="absolute z-999 right-2 bottom-2 bg-primary-100 bg-opacity-30 text-gray-500 text-xs font-semibold px-2 rounded-full"
>
  {{ copyRight }}
</div>
